import { DEFAULT_LOCALE } from '@rover/constants/src/i18n/locale';
import useFrontendConfigurationShim from '@rover/shared/js/hooks/useFrontendConfigurationShim';

import Trustpilot, { TrustPilotProps } from './Trustpilot';

type Props = Omit<TrustPilotProps, 'locale'>;

const TrustPilotContainer: React.FC<Props> = (props: Props) => {
  const { language: locale = DEFAULT_LOCALE } = useFrontendConfigurationShim();
  return <Trustpilot locale={locale} {...props} />;
};

export default TrustPilotContainer;
